import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {TReportFilters} from 'src/containers/Agent';
import {listenerMiddleware} from 'src/models';

const initialState = () => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.AGENTS_CLIENTS_PAYMENTS_FILTERS);

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
  };
};

const agentClientsPaymentsSlice = createSlice({
  name: 'agentClientsPayments',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TReportFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction} = agentClientsPaymentsSlice.actions;
export const selectFilters = (state: TRootState) =>
  state.agentClientsPayments.filters as TReportFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(
      EStorageKeys.AGENTS_CLIENTS_PAYMENTS_FILTERS,
      JSON.stringify(action.payload),
    );
  },
});

export default agentClientsPaymentsSlice.reducer;
